import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder } from 'styles/themeUtils';

const HeadingWrapper = styled.div`
  width: 100%;

  ${paddingBuilder.all(2, 1, 4, 1)}

  ${tablet768`
    ${paddingBuilder.top(3.5)}
  `}
`;

HeadingWrapper.displayName = 'HeadingWrapper';

export default HeadingWrapper;
